import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/announcement_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  title_cont: {
    model_name: 'Announcement',
    column_type: 'string',
    column_name: 'title',
  },
  fund_id_eq: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'Announcement',
  },
  fund: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'Announcement',
  },
}
export const formColumnsConfig = {
  'self': {
    'fund_id': { required: true, disabledUpdate: false },
    'content_type': { required: true, disabledUpdate: false },
    'title': { required: false, disabledUpdate: false },
    'published_at': { required: false, disabledUpdate: false },
    'content': { required: false, disabledUpdate: false },
    'markdown_content': { required: false, disabledUpdate: false },
    'pdf_file': { required: false, disabledUpdate: false },
    'announced_at': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Announcement', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Announcement', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
